/**
 * Government Intake API constants.
 * Backend: OS routes = /v0/os/government_intakes (admin). Shared routes = /v0/shared/government_intakes (public form submit).
 */

import { baseUrl } from '@/api/base';

/** Backend: GET list/detail, POST/PATCH/DELETE via shared.routes.ts (OS scope). */
export const BASE_PATH = `${baseUrl.OS}/government_intakes`;

/** Backend: POST create (public), POST assets/sign, POST system-pending via shared.routes.ts (shared scope). */
export const BASE_PATH_SHARED = `${baseUrl.SHARED}/government_intakes`;
